// Meta "Lead" and "Contact" — the two events the Facebook & Instagram sales
// channel cannot see, because they happen in the theme rather than in the cart
// or checkout. The pixel itself is set up in snippets/meta-pixel.liquid.
//
// Lead fires on the page Shopify shows AFTER a successful submission, never on
// submit, so failed posts and captcha drop-outs are not counted:
//   - Contact form: Shopify redirects to `?contact_posted=true#ContactForm` and
//     renders `[data-form-success]`.
//   - Tank calculator: either `#CalculatorForm` with the success banner visible,
//     or `?sendt=1` — the page calculator-return.js sends the visitor on to after
//     Shopify's captcha dropped them on the front page.
// The anchor is checked as well as the success markup because
// `form.posted_successfully?` is not scoped per form: a newsletter sign-up on
// the same page would otherwise make the contact form report success too.
// The newsletter itself is deliberately not a Lead.
//
// A reload or back/forward to the confirmation page is not a new enquiry, so
// only a fresh navigation counts.
//
// Contact fires on any click on a tel: or mailto: link, wherever it is.
//
// Debug: ?tracking_debug=1 or localStorage.setItem('theme:tracking:debug', '1').
(function () {
  const DEBUG_QUERY = /(?:\?|&)tracking_debug=1(?:&|$)/;
  const DEBUG_STORAGE_KEY = 'theme:tracking:debug';

  function debugLog(...args) {
    try {
      if (DEBUG_QUERY.test(window.location.search || '') ||
        window.localStorage?.getItem(DEBUG_STORAGE_KEY) === '1') {
        console.log('[theme-tracking]', ...args);
      }
    } catch (error) {
      // Storage can throw in private mode; debugging is not worth an error.
    }
  }

  function track(event, data) {
    if (typeof window.fbq !== 'function') {
      debugLog(`Skipped Meta ${event} - window.fbq is unavailable`);
      return;
    }
    window.fbq('track', event, data);
    debugLog(`Sent to Meta Pixel: ${event}`, data);
  }

  function isFreshNavigation() {
    try {
      const entry = performance.getEntriesByType('navigation')[0];
      return !entry || entry.type === 'navigate';
    } catch (error) {
      return true;
    }
  }

  function detectLead() {
    const hash = window.location.hash;
    const params = new URLSearchParams(window.location.search);

    // Shopify appends the form's id as the anchor; accept a missing anchor too,
    // but never another form's.
    const contactPosted = hash === '#ContactForm' || (!hash && params.get('contact_posted') === 'true');
    if (contactPosted && document.querySelector('#ContactForm [data-form-success]')) {
      return 'Kontaktformular';
    }

    const calculatorSuccess = document.querySelector('tank-calculator [data-calc-success]:not([hidden])');
    if (calculatorSuccess && (hash === '#CalculatorForm' || params.get('sendt') === '1')) {
      return 'Tankberegner';
    }

    return null;
  }

  function trackLead() {
    const form = detectLead();
    if (!form) return;
    if (!isFreshNavigation()) {
      debugLog(`Lead (${form}) skipped - page was reloaded or reached via back/forward`);
      return;
    }
    track('Lead', { content_name: form, content_category: 'Formular' });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href^="tel:"], a[href^="mailto:"]');
    if (!link) return;
    const isPhone = link.getAttribute('href').startsWith('tel:');
    track('Contact', { content_name: isPhone ? 'Telefon' : 'Mail' });
  });

  // tank-calculator.js reveals the banner on `?sendt=1` when its element is
  // defined. Both scripts are deferred, but a module can finish later than a
  // classic script, so wait for the element before looking.
  function init() {
    if (document.querySelector('tank-calculator') && window.customElements) {
      customElements.whenDefined('tank-calculator').then(trackLead);
    } else {
      trackLead();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
